import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import CircularProgress from '@mui/material/CircularProgress'
import { TranscriptionType } from '../../../../lib/types'
import TranscriptEditor from '../../../../components/TranscriptEditor'

interface iTranscript {
  storyId: string
  handleView: () => void
  time: number
  transcription?: TranscriptionType
  isLoading: boolean
}

const LateralTranscript: React.FC<iTranscript> = ({ time, transcription, isLoading }) => {
  const [localTranscription, setLocalTranscription] = useState<TranscriptionType | undefined>(undefined)

  useEffect(() => {
    setLocalTranscription(transcription)
  }, [transcription])

  return (
    <>
      <Box
        component={Paper}
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '100%',
          padding: 0,
          flexFlow: 'column',
          overflowY: 'scroll',
          maxHeight: '620px'
        }}
      >
        {isLoading ? (
          <CircularProgress variant="indeterminate" />
        ) : (
          <>
            {!localTranscription ? (
              <Typography component="pre" align="justify" paragraph>
                We haven&apos;t finished generating the transcript. Please check back later.
              </Typography>
            ) : (
              <>
                <TranscriptEditor
                  transcriptJson={localTranscription!.cooked}
                  currentTime={time}
                  isEditable={false}
                  onChange={() => undefined}
                />
              </>
            )}
          </>
        )}
      </Box>
    </>
  )
}

export default LateralTranscript
